import React, { useState, useEffect } from "react";
import { FUNCTION_DETAILS_LISTING_COLUMNS } from "../../../utils/constant";
import {
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Checkbox,
  Typography,
  Tooltip,
  TableSortLabel,
  Box,
  IconButton
} from "@mui/material";
import RecordNotFound from "../../../common/RecordNotFound";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ADD_FUNCTION_VALIDATIONS } from "../../../utils/Validation";
import AddFunction from "./AddFunction";
import Add from "@mui/icons-material/Add";
import { visuallyHidden } from "@mui/utils";
import {
  onUpdateFunctionService,
  functionChangeStatusService,
  onAddFunctionService,
} from "../../../services/UserOnboardingService";
import useGlobalState from "../../../Context";
import EditIcon from "@mui/icons-material/Edit";

const FunctionList = ({
  totalElements,
  onSearch,
  handleTableChanges,
  setLoading,
  showNotification,
  departmentList,
  fetchDepartmentList,
  fetchFunctionList,
  functionList,
  setFunctionList,
  noRecord,
}) => {
  const [searchedRows, setSearchedRows] = useState(functionList);
  const [functionNameSearch, setFunctionNameSearch] = useState("");
  const [clearSearch, setClearSearch] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  // const [searchwith, setSearchwith] = useState("");
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openAddFunctionDialog, setOpenAddFunctionDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({});
  const [selected, setSelected] = useState([]);
  const [departNameForFunct, setDeptNameForFunction] = useState("");
  const [disableUpdateButton, setDisbaleUpdateButton] = useState(true);
  const [isUpdateButton, setIsUpdateButton] = useState(true);
  const [functionId, setFunctionId] = useState("");
  const [sortValue, setSortValue] = useState('ASC');
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("name");
  const [isSearchBtnClick, setIsSearchBtnClick] = useState(false);
  const [searchValue_, setsearchValue_] = useState(null);
  const [{ auth }, dispatch] = useGlobalState();
  const loginUserId = auth.ldapParam.userId;
  const [formValues, setFormValues] = useState({
    createdOn: new Date(),
    createdBy: loginUserId,
    active: 1,
  });

  const formOption = {
    resolver: yupResolver(ADD_FUNCTION_VALIDATIONS),
    defaultValues: { ...formData },
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
    setValue
  } = useForm(formOption);

  useEffect(() => {
    reset(formData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openAddFunctionDialog]);

  useEffect(() => {
   
    setSearchedRows(functionList);
  }, [functionNameSearch, functionList]);

  const searchText = async (e) => {
    setSearchValue(e.target.value);
   
    setFunctionNameSearch("");
    e.target.value === "" ? setClearSearch(false) : setClearSearch(true);
    if (e.target.value === "") {
      onclickClear();
    }
  };

  const handleClickOpenFunctionDialog = () => {
    setOpenAddFunctionDialog(true);
    fetchDepartmentList();
  };
  const handleCloseFunctionDialog = () => {
    setOpenAddFunctionDialog(false);
    setIsEditMode(false);
    setIsUpdateButton(true);
    setFormData({});
  };

  const searchOnClick = async (type) => {
    try {
      setLoading(true);
     
      const requestBody = {
        status: true,
        pageNumber: 0,
        pageSize: rowsPerPage ?? 10,
        isAsc: order,
        orderBy: orderBy,
        search: searchValue && searchValue.trim(),
      };
      setIsSearchBtnClick(true);
      setsearchValue_(searchValue)
      await onSearch(requestBody, searchValue && searchValue.trim());
      setSelected([]);
      setDisbaleUpdateButton(true)
      setPage(0);
      setMaxPage(0)
      
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch  details");
    } finally {
      setLoading(false);
    }
    // setSearchwith(type);
    setFunctionNameSearch(searchValue && searchValue.trim());
  };

  const onclickClear = async () => {
  
    const requestBody = {
      status: true,
      pageNumber: page,
      pageSize: rowsPerPage ?? 10,
      isAsc: order,
      orderBy: orderBy,
     };
     setsearchValue_(null);
    await fetchFunctionList("name", false,null,null,requestBody);
    setSelected([]);
    setDisbaleUpdateButton(true)
    setSearchValue("");
    setPage(0);
    // setRowsPerPage(10)
    setMaxPage(0);
    setClearSearch(false);
    setFunctionNameSearch("");
    setIsSearchBtnClick(false);
  };

  const handleChangeRowsPerPage = async (event) => {
    const paginationValues = {
      pageNumber: 0,
      pageSize: +event.target.value,
    };
   
    await handleTableChanges(paginationValues, false, 'null', sortValue, orderBy, searchValue_);
    setPage(0);
    setMaxPage(0);
    setRowsPerPage(+event.target.value);
  };

  const handleChangePage = async (event, newPage) => {
    if (newPage > page  && newPage > maxPage) {
      setMaxPage(newPage);
      const paginationValues = {
        pageNumber: newPage,
        pageSize: rowsPerPage,
      };
      await handleTableChanges(paginationValues, true, 'null', sortValue, orderBy, searchValue_);
    }
    setPage(newPage);
  };

  const onAddFunctionSubmit = async (data) => {
    try {
      let obj = {
        deptId: parseInt(data.deptId),
        name: data.name && data.name.trim(),
        functionId: functionId ? functionId : 0,
        functionCode: data.functionCode && data.functionCode.trim(),
        modifiedOn: formValues.createdOn,
        modifiedBy: formValues.createdBy,
        createdOn: formValues.createdOn,
        createdBy: formValues.createdBy,
        active: formValues.active ? true : false,
        
      };
      const res = !isEditMode
        ? await onAddFunctionService(obj)
        : await onUpdateFunctionService(obj);
      if (res.statusCode == "6") {
        const newFamilyList = [...functionList];
        const index = newFamilyList.findIndex(
          (x) => x.functionId === functionId
        );
        newFamilyList[index] = { ...functionList[index], ...obj };
        setFunctionList(newFamilyList);
        handleCloseFunctionDialog(false);
        setIsUpdateButton(true);
        setSelected([]); setDisbaleUpdateButton(true);
        showNotification("Success", res.message, "success");
        onclickClear()
        // await fetchFunctionList("name", true);
        // setPage(0);
        // setMaxPage(0)
        
      } else {
        handleCloseFunctionDialog(false);
        showNotification("Error", res.message, "error");
      }
    } catch (err) {
      handleCloseFunctionDialog(false);
      showNotification("Error", "Faild to add ", "error");
      throw err;
    }
  };

  const handleClickEditFunction = (item) => {
    if (item) {
      reset(item);
    }
  
    fetchDepartmentList();
    setOpenAddFunctionDialog(true);
    setIsEditMode(true);
    //setFunctNameForDepart(item.categoryName);
    setFunctionId(item.functionId);
    setFormValues({
      createdOn: item?.createdOn,
      createdBy: item.createdBy ? item.createdBy : 1,
      active: item?.active ? item.active : 0,
    });
    setFormData({ ...item });
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - functionList.length)
      : 0;

  const handleActiveChange = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
    if (newSelected.length !== 0) {
      setDisbaleUpdateButton(false);
    } else {
      setDisbaleUpdateButton(true);
    }
    const newSearchedRow = functionList.map((currentRow) => {
      if (currentRow.functionId === id) {
        return {
          ...currentRow,
          active: event.target.checked,
        };
      }
      return currentRow;
    });
    setFunctionList(newSearchedRow);
  };

  const onChangeStatusSubmit = async () => {
    const resultRecords = [];
    selected.forEach((itemId) => {
      const tempItem = functionList.find(
        (record) => record.functionId === itemId
      );
      if (tempItem) {
        resultRecords.push({
          active: tempItem.active,
          functionId: tempItem.functionId,
        });
      }
    });
    try {
      const res = await functionChangeStatusService(resultRecords);
      if (res.statusCode == "6") {
        //await fetchFunctionList("name", true);
        setSelected([]);
        showNotification("Success", res.message, "success");
        setDisbaleUpdateButton(true);
      } else {
        showNotification("Error", res.message, "error");
      }
    } catch (e) {
    } finally {
    }
  };

  const handleRequestSort = (event, property) => {

    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);

    const paginationData={
      pageNumber: page,
      pageSize: rowsPerPage,
      isAsc: order,
      orderBy: orderBy
     };
     setSelected([]);
     setDisbaleUpdateButton(true)
    fetchFunctionList(property, isAsc, 'null', searchValue_&& searchValue_.trim(),paginationData);
    setSortValue(isAsc ? "DESC" : "ASC");
    setPage(0);
    setMaxPage(0);
    
  };

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 7 }}>
        <Grid container spacing={2} sx={{ px: 0 }} display="flex">
          <Grid item xs={6} md={4}>
            <Typography
              align="left"
              sx={{ mr: "auto", color: "#003f93" }}
              variant="h6"
            >
              Function Listing ( {totalElements ? totalElements : 0} )
            </Typography>
          </Grid>
          <Grid item xs={6} md={8}>
            <Typography align="right">
              <div className="searchContainer">
              
                <input
                  type="text"
                  placeholder="By Function Name"
                  onChange={searchText}
                  className="searchInput2"
                  value={searchValue}
                />
                <IconButton disabled={searchValue === ""} className={searchValue === "" ? 'searchIcon':'filPrimaryColor searchIcon'}>
                <SearchIcon
                 // className="searchIcon"
                  onClick={() => searchOnClick("name")}
                />
                </IconButton>
                {clearSearch && (
                  <ClearIcon
                    sx={{ fontSize: "22px", color: "red" }}
                    className="brandSearchClear"
                    onClick={onclickClear}
                  />
                )}
              </div>
              <Tooltip title="Add Function">
                <Button
                  variant="contained"
                  onClick={() => {
                    handleClickOpenFunctionDialog();
                  }}
                  sx={{ ml: 1 }}
                  className="button-primary-alt-contained"
                  startIcon={<Add />}
                >
                  Add Function
                </Button>
              </Tooltip>
              <Tooltip title="Update Function Status">
                <Button
                  variant="contained"
                  sx={{ ml: 1 }}
                  className="button-primary-alt-contained"
                  onClick={onChangeStatusSubmit}
                  disabled={disableUpdateButton}
                >
                  Status Update
                  {selected.length !== 0 &&
                    ` (${Object.keys(selected).length})`}
                </Button>
              </Tooltip>
            </Typography>
          </Grid>
          <Grid item xs={12} mb={4} sx={{ mt: 2 }}>
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer sx={{ maxHeight: 720 }}>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  // sx={{ minWidth: 750 }}
                  aria-labelledby="tableTitle"
                  size="small"
                >
                  <EnhancedTableHead
                    numSelected={selected.length}
                    // onSelectAllClick={handleSelectAllClick}
                    rowCount={searchedRows && searchedRows.length}
                    onRequestSort={handleRequestSort}
                    order={order}
                    orderBy={orderBy}
                  />
                  {searchedRows && searchedRows.length > 0 ? (
                    <TableBody sx={{ mt: 2 }}>
                      {searchedRows
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => {
                          const isItemSelected = isSelected(
                            row.functionId
                          );
                          const labelId = `enhanced-table-checkbox-${index}`;
                          return (
                            <TableRow
                              hover
                              tabIndex={-1}
                              role="checkbox"
                              aria-checked={isItemSelected}
                              selected={isItemSelected}
                              key={row.functionId}
                            >
                              <TableCell size="small" key={"name"}>
                                {row["name"] ?? "-"}
                              </TableCell>
                              <TableCell size="small" key={"functionCode"}>
                                {row["functionCode"] ?? "-"}
                              </TableCell>
                              <TableCell size="small" key={row.department["name"]}>
                                {row.department["name"] ?? "-"}
                              </TableCell>
                              <TableCell align="left">
                                {" "}
                                <Checkbox
                                  color="primary"
                                  // checked={row.active}
                                  checked={(isItemSelected, row.active)}
                                  classes={{root: 'custom-checkbox-root'}}
                                  onClick={(event) =>
                                    handleActiveChange(
                                      event,
                                      row.functionId
                                    )
                                  }
                                  inputProps={{
                                    "aria-labelledby": labelId,
                                  }}
                                />
                              </TableCell>
                              <TableCell>
                              <EditIcon
                                  sx={{
                                    fontSize: "20px",
                                    cursor: "pointer",
                                    color: "#567aac",
                                    height: "18px", 
                                    width: "18px" 
                                  }}
                                 
                                  onClick={() => handleClickEditFunction(row)}
                                />
                               </TableCell>
                            </TableRow>
                          );
                        })}
                      {emptyRows > 0 && (
                        <TableRow
                          style={{
                            height: 33 * emptyRows,
                          }}
                        >
                          <TableCell colSpan={4} />
                        </TableRow>
                      )}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        {noRecord ? (
                          <TableCell colSpan={4}>
                            <RecordNotFound />
                          </TableCell>
                        ) : (
                          <TableCell colSpan={4} />
                        )}
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
              {searchedRows && searchedRows.length > 0 ? (
                <TablePagination
                  className="newPagination"
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  component="div"
                  count={totalElements}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              ) : null}
            </Paper>
            <AddFunction
              openDialog={openAddFunctionDialog}
              handleClose={handleCloseFunctionDialog}
              register={register}
              setError={setError}
              handleSubmit={handleSubmit}
              errors={errors}
              departmentList={departmentList}
              onAddFunctionSubmit={onAddFunctionSubmit}
              //setFunctNameForDepart={setFunctNameForDepart}
              formData={formData}
              isEditMode={isEditMode}
              isUpdateButton={isUpdateButton}
              setIsUpdateButton={setIsUpdateButton}
              setDeptNameForFunction={setDeptNameForFunction}
              setValue = {setValue}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default FunctionList;

function EnhancedTableHead({ onRequestSort, order, orderBy }) {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow key={"1"}>
        {FUNCTION_DETAILS_LISTING_COLUMNS.map((headCell) => (
          <TableCell
            size="small"
            variant="head"
            className="tableHeader"
            sx={{ pt: 1.5, pb: 1.5 }}
            key={headCell.productCatFamilyMappingId}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            style={{
              minWidth: headCell.minWidth,
              // backgroundColor: "lightgray",
              fontWeight: "bold",
              color: "#003A6B",
            }}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              disabled={
                (headCell.id === "action" ||headCell.id === "Dname" || headCell.id === "active") && true
              }
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
